import React from 'react';
import { motion } from 'framer-motion';
const categories = [{
  num: '01',
  title: 'Prompts de Ventas',
  desc: 'Estructuras persuasivas para convertir seguidores en clientes sin sonar desesperado.',
  count: '100 Prompts',
  examples: ['Actúa como un copywriter experto y redacta un email de ventas para...', 'Crea 3 ángulos de venta diferentes para mi servicio de...']
}, {
  num: '02',
  title: 'Prompts de Contenido',
  desc: 'Sistemas para generar meses de contenido en minutos, adaptado a tu voz.',
  count: '150 Prompts',
  examples: ['Genera un carrusel educativo de 5 slides sobre [tema]...', 'Transforma este artículo de blog en 3 guiones para Reels...']
}, {
  num: '03',
  title: 'Prompts para Realtors',
  desc: 'Descripciones de propiedades, guiones de seguimiento y captación de leads.',
  count: '80 Prompts',
  examples: ['Redacta una descripción de lujo para una propiedad con...', 'Crea un guion de llamada en frío para propietarios que...']
}, {
  num: '04',
  title: 'Prompts de Productividad',
  desc: 'Automatiza tareas aburridas, resume reuniones y organiza tu semana.',
  count: '70 Prompts',
  examples: ['Resume estas notas de reunión en 3 puntos de acción clave...', 'Crea un bloque de tiempo ideal basado en estas tareas...']
}, {
  num: '05',
  title: 'Negocios & Productos Digitales',
  desc: 'Ideas de infoproductos, validación de mercado y estrategias de lanzamiento.',
  count: '100 Prompts',
  examples: ['Diseña el temario para un curso online sobre...', 'Crea una estrategia de lanzamiento de 14 días para...']
}];
export function WhatsInside() {
  return <section id="incluye" className="py-24 md:py-32 relative" data-id="element-406">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-407">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 md:mb-24" data-id="element-408">
          <h2 className="font-display text-4xl md:text-5xl text-cream mb-6" data-id="element-409">
            Lo que encontrarás dentro
          </h2>
          <p className="text-cream/60 max-w-2xl text-lg font-light" data-id="element-410">
            Una biblioteca categorizada y lista para copiar y pegar. Diseñada
            para cubrir cada aspecto de tu negocio digital.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-411">
          {categories.map((cat, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className={`bg-gradient-to-br from-black-200 to-black-100 border border-gold/15 p-8 rounded-sm relative overflow-hidden group hover:border-gold/40 hover:from-black-300 hover:to-black-200 transition-all duration-500 shadow-[0_4px_24px_-8px_rgba(0,0,0,0.6)] hover:shadow-[0_8px_32px_-4px_rgba(212,175,122,0.08)] ${idx === 0 || idx === 3 ? 'md:col-span-2 lg:col-span-2' : ''}`} data-id="element-412">
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent opacity-60" data-id="element-413"></div>
              <div className="flex justify-between items-start mb-8" data-id="element-414">
                <span className="font-display text-3xl text-gold/30 group-hover:text-gold/60 transition-colors" data-id="element-415">
                  {cat.num}
                </span>
                <span className="text-[10px] uppercase tracking-widest text-gold border border-gold/20 px-3 py-1 rounded-full bg-gold/5" data-id="element-416">
                  {cat.count}
                </span>
              </div>

              <h3 className="text-2xl font-display text-cream mb-3" data-id="element-417">
                {cat.title}
              </h3>
              <p className="text-cream/60 font-light text-sm mb-8 max-w-md" data-id="element-418">
                {cat.desc}
              </p>

              <div className="space-y-3" data-id="element-419">
                <p className="text-[10px] uppercase tracking-widest text-cream/40" data-id="element-420">
                  Ejemplos incluidos:
                </p>
                {cat.examples.map((ex, i) => <div key={i} className="bg-black/50 border border-white/5 p-3 rounded text-xs text-cream/70 font-mono italic" data-id="element-421">
                    "{ex}"
                  </div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}